<template>
    <div v-if="exist" v-show="visible" class="md-demographic classic">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="title-container">
                <div
                    class="mg-title"
                    v-html="formatFontSize(title, '--mg-title-size')"
                ></div>
                <a
                    :href="listingDetail.introUrlByListing"
                    v-if="listingDetail.introUrlByListing"
                    rel="noopener noreferrer"
                    class="refine-intro"
                ><i class="iconfont icon-community"></i
                >{{ $t('md-demographic.refineSearch') }}</a
                >
            </div>
            <ul class="demographic-content">
                <template
                    v-for="(item, index) in demographics"
                    :key="'item' + item.label + index"
                >
                    <li class="item">
                        <div class="info">
                            <p class="number" data-format="${item.type}">
                                {{ item.value }}
                            </p>
                            <p class="text">{{ item.label }}</p>
                        </div>
                    </li>
                    <li class="divide">
                        <span></span>
                    </li>
                </template>
            </ul>
            <div
                class="source"
                v-html="$t('md-demographic.dataProvidedBy')"
            ></div>
        </module-box>
    </div>
</template>

<script>
import Common from '../index.js';
export default {
    mixins: [Common],
    data: function() {
        return {};
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
.md-demographic.classic {
    overflow: visible;
    .mg-title {
        padding-bottom: 0px;

        .mg-more {
            color: #727272;
            text-transform: capitalize;
            font-family: var(--font-normal);
            font-size: 14px;
            float: right;
            letter-spacing: 0;
            .iconfont {
                display: inline-block;
                transform: rotate(-90deg);
            }
        }
    }
    .mg-container {
        overflow: visible;
        .title-container {
            display: flex;
            align-content: center;
            justify-content: space-between;
            .refine-intro {
                font-size: 14px;
                color: #505050;
                font-family: var(--font-medium);
                line-height: 26px;
                display: flex;
                align-items: center;
                white-space: nowrap;
                .iconfont.icon-community {
                    margin-right: 10px;
                    color: #a8a8a8;
                }
            }
            .mg-title{
                flex-basis: fit-content;
                margin-left: 0;
            }
        }
    }
    .source {
        padding: 10px 0;
        color: var(--color-info);
        font-size: 12px;
        line-height: 16px;
        a {
            text-decoration: underline;
            color: var(--color-theme, #03c9ff);
        }
    }
    .demographic-content {
        margin-top: 20px;
        min-height: 168px;
        background: white;
        padding: 0 60px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        position: relative;
        border: 1px solid #e5ebf1;
        .item {
            margin: 10px 0;
            display: flex;
            align-items: center;
            float: none;
            .info {
                .number {
                    font-size: 30px;
                    line-height: 36px;
                    color: #282828;
                }
                .text {
                    color: #a0a0a0;
                    font-size: 16px;
                    line-height: 19px;
                    margin-top: 12px;
                }
            }
        }
        .divide {
            flex: 1;
            padding: 0 10px;
            &:last-child {
                display: none;
            }
            span {
                width: 1px;
                height: 60px;
                background-color: #d8d8d8;
                opacity: 0.6;
                display: block;
                margin: 0 auto;
            }
        }
    }
    @include media-600 {
        .demographic-content {
            padding: 0;
            width: auto;
            margin-top: 14px;
            border: none;

            .item {
                width: calc(50% - 2px);
                height: 87px;
                margin: 0px;
                justify-content: center;
            }
            .divide {
                flex: none;
                padding: 0px;
                &:nth-child(4n) {
                    display: none;
                }
            }
        }
    }
}
</style>
